import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { Popover, Dropdown } from 'bootstrap';

function Root() {
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      // 1. 기존 Popover DOM 제거
      document.querySelectorAll('.popover')?.forEach(p => p.remove());

      // 2. Popover 인스턴스 정리 및 재생성
      const popoverTriggers = document.querySelectorAll('[data-bs-toggle="popover"]');
      popoverTriggers.forEach(el => {
        const instance = Popover.getInstance(el);
        if (instance) instance.dispose();
        new Popover(el);
      });

      // ✅ 3. Dropdown 인스턴스도 정리 및 재생성
      const dropdownTriggers = document.querySelectorAll('[data-bs-toggle="dropdown"]');
      dropdownTriggers.forEach(el => {
        const dropdownInstance = Dropdown.getInstance(el);
        if (dropdownInstance) dropdownInstance.dispose();
        new Dropdown(el);
      });

    }, 100);

    return () => clearTimeout(timeout);
  }, [location]);

  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Root;
